import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getCategory } from "../lib/firebase/category/read_server";
import { getAllPostsWithCategory } from "../lib/firebase/post/read_server";
import PostCard from "./PostCard";

export default function CategoryPostsPage() {
    const { categoryId } = useParams();
    const [category, setCategory] = useState(null);
    const [posts, setPosts] = useState([]);

    useEffect(() => {
        async function fetchCategory() {
            const fetchedCategory = await getCategory(categoryId);
            setCategory(fetchedCategory);
        }
        async function fetchPosts() {
            const fetchedPosts = await getAllPostsWithCategory(categoryId);
            setPosts(fetchedPosts);
        }
        fetchCategory();
        fetchPosts();
    }, [categoryId]);

    if (!category) {
        return <div className="text-center mt-5">Loading Category...</div>;
    }

    return (
        <main className="container mt-4">
            <div className="d-flex align-items-center p-3 bg-light border rounded">
                <h4 className="fw-bold mb-0 me-2">Categories /</h4>
                <CategoryCard category={category} />
            </div>
            <div className="row mt-4">
                {posts.length > 0 ? (
                    posts.map((post, key) => (
                        <div key={key} className="col-md-3 mb-4">
                            <PostCard post={post} />
                        </div>
                    ))
                ) : (
                    <div className="text-center w-100 mt-4">
                        <p>No posts found in this category.</p>
                    </div>
                )}
            </div>
        </main>
    );
}

function CategoryCard({ category }) {
    return (
        <div className="d-inline-flex align-items-center bg-light border rounded px-3 py-1">
            <img
                className="rounded-circle me-2"
                src={category?.iconURL}
                alt="Category"
                width="20"
                height="20"
            />
            <h5 className="text-muted mb-0">{category?.name}</h5>
        </div>
    );
}
